// ESM-Huelle um lib/scripts/pos/CLS_CBonRenderer.js (Phase 4, Welle 3) -
// Bildschirm-Redraw/Summen, eines der sechs beim BonManager-Refactor extrahierten
// Module (Prototype-Mixin, wird im CBonManager-Konstruktor an die
// Instanz gebunden). Prototype-Stil bleibt vorerst.
// Strict-Mode-Fix (ESM): diese Namen wurden im Classic-Sloppy-Mode als
// implizite window-Globals angelegt (Zuweisung ohne var) - in Modulen
// wirft das ReferenceError. Modul-weite Deklaration stellt das alte
// Verhalten (dateiuebergreifend ungenutzte Temp-Variablen) her.
var Cnt;


function CBonRenderer() {}

CBonRenderer.prototype.initDisplay = function () {
    if (typeof this.Main == "undefined")
        return;

    var currentUserName = this.Main.userProps.Name;
    var currentUserNames = currentUserName.split(' ');
    if (currentUserNames.length > 0) {
        currentUserNames[currentUserNames.length - 1] = currentUserNames[currentUserNames.length - 1].substring(0, 1) + ".";
        currentUserName = "";
        for (var i = 0; i < currentUserNames.length; i++) {
            currentUserName = currentUserName + currentUserNames[i] + " ";
        }
    }
    Display.addLine();
    Display.addElement(POS.lang.getText("DISPLAY", "SERVED_BY"), 9, 2, 0, 19);
    Display.addLine();
    Display.addElement(currentUserName, 9, 2, 0, 19);
    Display.out();
}

CBonRenderer.prototype.redrawBon = function (Entry, toPrinter) {
    var HaveManualRebate = false,
    HaveAutoRebate = false;
    var height = 0;
    var BonManagerClass = this;
    var def = $.Deferred();
    var defret = $.Deferred();
    // Rebuild Bon
    // Clear current Bon
    if (!toPrinter) {
        if (!(Entry.index == null) && this.gridLinks[Entry.index])
            this.gridLinks[Entry.index].clear();
    }

    height += this.addLine(Entry, toPrinter, 0);

    if (Entry.cancelled && toPrinter)
        return;

    var ReferencedBy;
    for (ReferencedBy in Entry.referencedBy)
        if (Entry.referencedBy[ReferencedBy].type == "MRB") {
            HaveManualRebate = true;
            break;
        }
    for (ReferencedBy in Entry.referencedBy)
        if (Entry.referencedBy[ReferencedBy].type == "ARB") {
            HaveAutoRebate = true;
            break;
        }

    if (HaveAutoRebate || HaveManualRebate) {
        if (HaveManualRebate)
            this.addEmptyLine(Entry, toPrinter, 0);

        for (ReferencedBy in Entry.referencedBy)
            if (Entry.referencedBy[ReferencedBy].type == "MRB") {
                height += this.addLine(Entry.referencedBy[ReferencedBy], toPrinter, 0);
            }

        if (HaveAutoRebate)
            height += this.addEmptyLine(Entry, toPrinter, 0);

        for (ReferencedBy in Entry.referencedBy)
            if (Entry.referencedBy[ReferencedBy].type == "ARB") {
                height += this.addLine(Entry.referencedBy[ReferencedBy], toPrinter, 0);
            }

        this.addEmptyLine(Entry, toPrinter, 0);

        var SumEntry = new CBonEntry(-1, "", "NIL", null,
                "", "", Entry, fix2Decimals(this.getEntrySum(Entry)), null, null, true);
        $.when(SumEntry.defreturn).done(function (c) {
            height += BonManagerClass.addLine(SumEntry, toPrinter, 0);
            def.resolve();
        });
    } else {
        def.resolve();
    }
    $.when(def).done(function () {
        // Exit if Printout
        if (toPrinter) {
            defret.resolve();
            return;
        }

        if (Entry.cancelled) {
            if (Entry == BonManagerClass.getSelectedItem())
                BonManagerClass.Grid.deSelect();

            BonManagerClass.gridLinksRow[Entry.index].selectable = false;
            BonManagerClass.gridLinksRow[Entry.index].row.properties.styles.textDecoration = "lineThrough";
            BonManagerClass.gridLinksRow[Entry.index].row.properties.styles.backgroundColor = "#CCCCCC";
            BonManagerClass.gridLinksRow[Entry.index].row.properties.styles.color = "#EE3333";
            BonManagerClass.gridLinksRow[Entry.index].row.reStyle();
        } else {
            if (BonManagerClass.gridLinksRow[Entry.index].row)
                BonManagerClass.gridLinksRow[Entry.index].row.onMousedown = BonManagerClass.toScanner;
        }

        BonManagerClass.gridLinksHeights[Entry.index] = height;

        var active = false;
        var currentPos = 0;

        BonManagerClass.isReclamationBon = false;
        for (var pos in BonManagerClass.currentBon) {
            if (BonManagerClass.currentBon[pos].type != "POS") {
                if (BonManagerClass.currentBon[pos].type == "REC" && !BonManagerClass.currentBon[pos].cancelled) {
                    if (!BonManagerClass.getSumArray()[6]) {
                        var text = POS.lang.getText("MESSAGES", "COMPLAIN_BON_ZERO");
                        POS.message.show(text, "info", "OK");
                    }
                    BonManagerClass.isReclamationBon = true;
                    break;
                }
                continue;
            }
            if (pos == Entry.index)
                active = true;

            currentPos += BonManagerClass.gridLinksHeights[pos];
        }

        // draw Bon
        $.when(BonManagerClass.gridLinks[Entry.index].reDraw()).done(function () {
            defret.resolve();
        });
    });
    return defret.promise();
}

CBonRenderer.prototype.toScanner = function (component, parameters) {
}

CBonRenderer.prototype.runRedrawBonArray = function () {
    var defret = $.Deferred()
        var CBonManagerClass = this;

    var is = Object.keys(this.redrawBonArray);
    var iterator = function it(j) {
        if (j < is.length) {
            var i = is[j];
            $.when(CBonManagerClass.redrawBon(CBonManagerClass.redrawBonArray[i], false)).done(function () {
                iterator(j + 1);
                return;
            });

        } else {
            CBonManagerClass.redrawBonArray = new Array();
            defret.resolve();
            return;
        }
    }
    iterator(0);
    return defret.promise();
}

CBonRenderer.prototype.redrawAll = function () {

    var BonManagerClass = this;
    var defret = $.Deferred();

    $.when(this.recalcAll()).done(function () {

        $.when(BonManagerClass.runRedrawBonArray()).done(function () {
            $.when(BonManagerClass.redrawBonSum()).done(function () {
                defret.resolve();
            });
        });
    });
    return defret.promise();
}

CBonRenderer.prototype.getEntrySum = function (Entry) {
    var sum = 0;
    var HaveManualRebate = false,
    HaveAutoRebate = false;

    sum += Number(Entry.amount);

    var ReferencedBy;

    for (ReferencedBy in Entry.referencedBy)
        if (Entry.referencedBy[ReferencedBy].type == "MRB")
            sum += Number(Entry.referencedBy[ReferencedBy].amount);

    for (ReferencedBy in Entry.referencedBy)
        if (Entry.referencedBy[ReferencedBy].type == "ARB")
            sum += Number(Entry.referencedBy[ReferencedBy].amount);

    return sum;
}

CBonRenderer.prototype.addEmptyLine = function (Entry, toPrinter, feed) {
    if (toPrinter && feed > 0) {
        Printer.addLine("B", 1, false, feed);
        return 0;
    } else if (this.Bon) {
        //TODO:
        return 5;
        var columns = new Array();

        columns.push(new CColumn(0, 0));
        columns[0].properties.styles.height = "5px";
        columns[0].properties.styles.emptyCells = "show";

        var index = Entry.reference ? Entry.reference.index : Entry.index;
        this.gridLinks[index].addRowWithColumns(columns);

        return 5;
    }
}

CBonRenderer.prototype.addLine = function (Entry, toPrinter, feed) {
    var index = Entry.reference ? Entry.reference.index : Entry.index;
    var height = 0;

    if (this.isPostCancelled) {
        var sign1 = "-";
        var sign2 = "";
    } else {
        sign1 = "";
        sign2 = "-";
    }

    if (Entry.type == "POS") {
        var amount = float2StringD2(Entry.amount);
        var amountUnit = float2StringD2(Entry.unitAmount);
        var quantity = float2StringD2(Entry.quantity);
        var vatShortcut = Entry.product.vatShortcut;
        var correctedPrice = float2StringD2(parseFloat(Entry.correctedPrice));
        if (parseFloat(Entry.quantity) == 1 && parseFloat(Entry.correctedPrice) == 0) {
            var amountFirstLine = amount;
            var vatFirstLine = vatShortcut;
        } else if (parseFloat(Entry.quantity) != 1 && parseFloat(Entry.correctedPrice) == 0) {
            amountFirstLine = amountUnit;
            vatFirstLine = "";
            var amountSecondLine = amount;
            var vatSecondLine = vatShortcut;
        } else {
            var amountFirstLine = "";
            var vatFirstLine = "";
            var textCorrectedLine = "statt " + float2StringD2(parseFloat(Entry.correctedPrice)) + " nur ";
            var amountCorrectedLine = amountUnit;

            if (parseFloat(Entry.quantity) == 1 && parseFloat(Entry.correctedPrice) != 0)
                var vatCorrectedLine = vatShortcut;
            else if (parseFloat(Entry.quantity) != 1 && parseFloat(Entry.correctedPrice) != 0) {
                vatCorrectedLine = "";
                amountSecondLine = amount;
                vatSecondLine = vatShortcut;
            }
        }

        if (toPrinter) {
            if (!Entry.cancelled) {
                height += this.addRawLine(index,
                    remAmericanComma(Entry.quantity), Entry.unit, Entry.text1,
                    sign1 + amountFirstLine, vatFirstLine, "POS", Entry.cancelled, toPrinter, feed);
                if (typeof textCorrectedLine != "undefined") {
                    height += this.addRawLine(index, "", "", textCorrectedLine,
                        sign1 + amountCorrectedLine, vatCorrectedLine, "POS", Entry.cancelled,
                        toPrinter, feed);
                }
                if (typeof amountSecondLine != "undefined") {
                    height += this.addRawLine(index, "", "", "",
                        sign1 + amountSecondLine, vatSecondLine, "POS", Entry.cancelled,
                        toPrinter, feed);
                }
            } else {
                height += this.addRawLine(index,
                    remAmericanComma(Entry.quantity), Entry.unit, Entry.text1,
                    sign1 + float2StringD2(Entry.amount), "", "POS", Entry.cancelled, toPrinter, feed);
                height += this.addRawLine(index,
                    remAmericanComma(Entry.quantity), Entry.unit, Entry.text1,
                    sign2 + float2StringD2(Entry.amount), "", "POS", Entry.cancelled, toPrinter, feed);
            }
        } else {
            height += this.addRawLine(index,
                remAmericanComma(Entry.quantity), Entry.unit, Entry.text1, "", "",
                "POS", Entry.cancelled, toPrinter);
            if (Entry.text2)
                height += this.addRawLine(index, "", "", Entry.text2, "", "", "POSRESULT", Entry.cancelled, toPrinter);
            height += this.addRawLine(index, "", "",
                float2formatString(Entry.quantity) + " x " +
                float2StringD2(Entry.unitAmount) + " = ",
                Number(Entry.correctedPrice) != 0 ? "" : sign1 + amount,
                Number(Entry.correctedPrice) != 0 ? "" : vatShortcut,
                "POS", Entry.cancelled, toPrinter, feed);

            if (Entry.correctedPrice != 0) {
                height += this.addRawLine(index, "", "", "statt " +
                    float2StringD2(parseFloat(Entry.correctedPrice) * Entry.quantity) +
                    " nur", sign1 + amount, vatShortcut, "POS", Entry.cancelled, toPrinter);
            }
        }
    } else if (Entry.type == "REC" || Entry.type == "FPR") {
        var text2 = Entry.text2 ? " " + Entry.text2 : "";
        height += this.addRawLine(index, "", "", Entry.text1 + text2, sign2 + float2StringD2(Math.abs(Entry.amount)), Entry.product.vatShortcut,
            "STD", Entry.cancelled, toPrinter, feed);
    } else {
        height += this.addRawLine(index, "", "", Entry.text1 + " " + Entry.text2, sign1 + float2StringD2(Entry.amount), "",
            "STD", Entry.cancelled, toPrinter, feed);
    }

    return height;
}

CBonRenderer.prototype.addRawLine = function (index, a, b, c, d, e, mode, cancelled, toPrinter, feed) {
    if (toPrinter) {
        Printer.addLine("A", 1, false, feed);
        Printer.addElement(a, 0, 0, 0, 0, 3);
        Printer.addElement(b, 4, 0, 0, 4, 8);
        Printer.addElement(c, 9, 0, 0, 9, 27);
        Printer.addElement(d, 39, 1, 0, 28, 39);
        Printer.addElement(e, 41, 1, 0, 40, 41);
        return 0;
    } else {
        var value = "";

        value = this.normalize(a, 3, "right");
        value = value + " " + this.normalize(b, 5, "left");
        value = value + " " + this.normalize(c, 25, "left");
        value = value + " " + this.normalize(d, 10, "right");
        value = value + " " + this.normalize(e, 1, "right");


        this.gridLinks[index].properties.styles.margin = "2px";

        if (this.gridLinks[index].properties.value != "")
            value = "\n" + value;

        this.gridLinks[index].properties.value =
            this.gridLinks[index].properties.value + value;

        return 13;
    }
}

CBonRenderer.prototype.normalize = function (value, length, align) {
    var result = String(value);
    var corrstr = result.replace("&euro;", "X");
    var corrstr = corrstr.replace("&uuml;;", "X");
    var corrstr = corrstr.replace("&Uuml;", "X");
    var corrstr = corrstr.replace("&auml;", "X");
    var corrstr = corrstr.replace("&Auml;", "X");
    var corrstr = corrstr.replace("&ouml;", "X");
    var corrstr = corrstr.replace("&Ouml;", "X");
    var corrstr = corrstr.replace("&szlig;", "X");

    var strlength = result.length - corrstr.length;

    if (align == "left") {
        result = result + "                              ";
        result = result.substr(0, length + strlength);
    } else if (align == "right") {
        result = "                              " + result;
        result = result.substr(result.length - length - strlength, length + strlength);
    }

    return result;
}

CBonRenderer.prototype.redrawBonSum = function (toPrinter) {
    var BonManagerClass = this;
    var sum = BonManagerClass.getSumArray();
    var defret = $.Deferred();

    var changedRebates = false;

    if (BonManagerClass.isPostCancelled) {
        var sign1 = "-";
        var sign2 = "";
    } else {
        sign1 = "";
        sign2 = "-";
    }

    if ((sum[1] == 0) && (toPrinter) && (BonManagerClass.printMode == 'yearly_voucher')) {
        var turnover = BonManagerClass.currentReceipt.TurnoverValue;
        sum[1] = turnover / 100;
        sum[0] = sum[1];
        sum[2] = sum[1];
        sum[3] = sum[1];
        sum[4] = sum[1];
        sum[5] = sum[1];
        sum[6] = sum[1];
    }

    // First recalculate rebates
    $.when(BonManagerClass.redrawBonSumAddRebate(false, "GRB", sum[1], "Rabatt", toPrinter)).done(function (changed1) {
        // Rebate
        changedRebates = changedRebates || changed1;
        $.when(BonManagerClass.redrawBonSumAddRebate(false, "CRB", sum[1], "Kundenrabatt", toPrinter)).done(function (changed2) {
            // Customer Rebate
            changedRebates = changedRebates || changed2;

            if (changedRebates) {
                sum = BonManagerClass.getSumArray();
            }
            // Cash Discount
            $.when(BonManagerClass.redrawBonSumAddRebate(false, "CDS", sum[3], "Gutschrift", toPrinter)).done(function (changed3) {
                changedRebates = changed3;

                if (changedRebates)
                    sum = BonManagerClass.getSumArray();

                // Now enter drawing

                if (!toPrinter)
                    BonManagerClass.SumGrid.clear();

                // Sum
                var magnification = sum[1] != sum[4] ? 1 : 2;
                BonManagerClass.addSumRawLine("Summe:", "", "", sign1 + float2StringD2(sum[1]) + " &euro;", toPrinter, 0, true, magnification, "A");
                if (magnification == 2)
                    BonManagerClass.addSumEmptyLine(toPrinter, 1);

                // Rebate
                $.when(BonManagerClass.redrawBonSumAddRebate(true, "GRB", sum[1], "Rabatt", toPrinter)).done(function (changed4) {
                    // Customer Rebate
                    $.when(BonManagerClass.redrawBonSumAddRebate(true, "CRB", sum[1], "Kundenrabatt", toPrinter)).done(function (changed5) {
                        if (sum[1] != sum[3]) {
                            // Sum
                            magnification = sum[3] != sum[4] ? 1 : 2;
                            BonManagerClass.addSumRawLine("Summe:", "", "", sign1 + float2StringD2(sum[3]) + " &euro;", toPrinter, 0, true, magnification, "A");
                            if (magnification == 2)
                                BonManagerClass.addSumEmptyLine(toPrinter, 1);
                        }

                        // Cash Discount
                        $.when(BonManagerClass.redrawBonSumAddRebate(true, "CDS", sum[3], "Gutschrift", toPrinter)).done(function (changed6) {
                            if (sum[3] != sum[4]) {
                                // Sum
                                BonManagerClass.addSumRawLine("Summe:", "", "", sign1 + float2StringD2(sum[4]) + " &euro;", toPrinter, 0, true, 2, "A");
                                BonManagerClass.addSumEmptyLine(toPrinter, 1);
                            }

                            if ((toPrinter && BonManagerClass.printMode == "cancelprotocol")) //|| BonManagerClass.printMode == 'yearly_voucher')
                                toPrinter = false;

                            if (BonManagerClass.isPaydown) {
                                BonManagerClass.addSumRawLine("Anzahlung:", "", "", sign1 + float2StringD2(sum[4] - sum[6]) + " &euro;", toPrinter, 0, true, 2, "A");
                                BonManagerClass.addSumEmptyLine(toPrinter, 1);
                                BonManagerClass.addSumRawLine("Offen:", "", "", sign1 + float2StringD2(sum[6]) + " &euro;", toPrinter, 0, true, 2, "A");
                                BonManagerClass.addSumEmptyLine(toPrinter, 1);
                            }

                            // VAT block
                            BonManagerClass.addSumEmptyLine(toPrinter, 1);
                            BonManagerClass.addSumRawLine("", "Netto", "MwSt.", "Brutto", toPrinter, 0, false, 1, "B");

                            $.when(BonManagerClass.getBonVat(true)).done(function (vG) {
                                var vatGrid = vG;
                                BonManagerClass.vatSums = vG;
                                for (var i in vatGrid["vat"]) {
                                    var vat = vatGrid["vat"][i];
                                    var net = vatGrid["net"][i];
                                    var gro = vatGrid["gro"][i];
                                    var sct = vatGrid["sct"][i];
                                    var corrVat = float2StringD2(i * 100);

                                    BonManagerClass.addSumRawLine(corrVat + "% (" + sct + "):", sign1 + float2StringD2(net) + " &euro;",
                                        sign1 + float2StringD2(vat) + " &euro;", sign1 + float2StringD2(gro) + " &euro;",
                                        toPrinter, 0, false, 1, "B");
                                }

                                var hasPayment = false;
                                var amountPaydown = 0;
                                var paydownBonId = null;
                                for (Cnt in BonManagerClass.currentBon) {
                                    var Entry = BonManagerClass.currentBon[Cnt];
                                    if (Entry.type == "PAY" && !Entry.cancelled && Entry.interaction != "PDN")
                                        hasPayment = true;
                                    if (Entry.interaction == "PDN" && !Entry.cancelled) {
                                        if (Entry.type == "PAY")
                                            amountPaydown += parseFloat(Entry.amount);
                                        else if (Entry.type == "RET")
                                            amountPaydown -= parseFloat(Entry.amount);
                                        paydownBonId = Entry.productId;
                                    }
                                }

                                if (hasPayment)
                                    BonManagerClass.addSumEmptyLine(toPrinter, 1);
                                $.when(Trans.getPosBonId(paydownBonId)).then(function (bonID) {
                                    // Paydown
                                    var def = $.Deferred();
                                    if (amountPaydown > 0) {
                                        var corrAmt = float2StringD2(amountPaydown);
                                        $.when(Trans.getTSFromBonId(paydownBonId)).then(function (ts) {
                                            $.when(Trans.getPosREGId(bonID)).done(function (POSREG_ID) {
                                                if (!POSREG_ID)
                                                    POSREG_ID = bonID;
                                                var d = new Date(parseFloat(ts) * 1000);
                                                var dateTimeToShow = d.getDate() + "." + (d.getMonth() + 1) + "." +
                                                    (d.getYear() + 1900);
                                                BonManagerClass.addSumPaydownLine("Anzahlung vom " + dateTimeToShow + ":", "", toPrinter);
                                                BonManagerClass.addSumPaydownLine("Rechn.nr. " + POSREG_ID, corrAmt + " &euro;", toPrinter);
                                                def.resolve();
                                            });
                                        });
                                    } else {
                                        def.resolve();
                                    }

                                    $.when(def).done(function () {
                                        // Payment
                                        if (hasPayment) {
                                            for (Cnt in BonManagerClass.currentBon) {
                                                Entry = BonManagerClass.currentBon[Cnt];
                                                if (Entry.type == "PAY" && !Entry.cancelled && Entry.interaction != "PDN") {
                                                    corrAmt = float2StringD2(Entry.amount);
                                                    switch (Entry.text1) {
                                                    case "BCC":
                                                        if (Entry.text2 == "CC" || Entry.text2 == "CCP")
                                                            var paymentType = POS.lang.getText("LABELS", "CREDITCARD");
                                                        else
                                                            paymentType = POS.lang.getText("LABELS", "DEBITCARD");
                                                        break;
                                                    case "VCR":
                                                        paymentType = POS.lang.getText("LABELS", "VOUCHER");
                                                        break;
                                                    case "BAR":
                                                        paymentType = POS.lang.getText("LABELS", "BAR");
                                                        break;
                                                    case "PPU":
                                                        paymentType = POS.lang.getText("LABELS", "PPU");
                                                        break;
                                                    case "CNT":
                                                        paymentType = POS.lang.getText("LABELS", "CENTRAL_PAYMENT");
                                                        break;
                                                    case "DLP":
                                                        paymentType = POS.lang.getText("LABELS", "DELIVERY_BILL");
                                                        break;
                                                    case "PPC":
                                                        paymentType = POS.lang.getText("LABELS", "PPCARD");
                                                        break;
                                                    default:
                                                        paymentType = Entry.text1;
                                                    }
                                                    BonManagerClass.addSumRawLine(paymentType, "", "", sign1 + corrAmt + " &euro;", toPrinter, 0, false, 1, "A");
                                                    for (var rb in Entry.referencedBy) {
                                                        corrAmt = float2StringD2(Entry.referencedBy[rb].amount);
                                                        BonManagerClass.addSumRawLine(POS.lang.getText("LABELS", "RETURN"), "", "", sign2 + corrAmt + " &euro;", toPrinter, 0, false, 1, "A");
                                                    }
                                                }
                                            }
                                        }

                                        // Exit if Printout
                                        if (toPrinter) {
                                            defret.resolve();
                                            return;
                                        }

                                        if (BonManagerClass.isPostCancelled)
                                            BonManagerClass.addSumRawLine("<b>STORNIERT</b>", "", "", "", 0, 0, true, 1, "A");

                                        BonManagerClass.SumGrid.reDraw();
                                        if (BonManagerClass.displayMode != "info")
                                            BonManagerClass.switchSumInfo(true);

                                        defret.resolve();
                                    });
                                });
                            });
                        });
                    });
                });
            });
        });
    });
    return defret.promise();
}

CBonRenderer.prototype.addSumPaydownLine = function (a, b, toPrinter) {
    if (toPrinter) {
        Printer.addLine("A", 1, false, 0);

        var ColLimits = new Array();
        ColLimits[0] = 31;
        ColLimits[1] = 42;

        Printer.addElement(a, 0, 0, false, 0, ColLimits[0] - 1);
        Printer.addElement(b, ColLimits[1] - 1, 1, false, ColLimits[0], ColLimits[1] - 1);
    } else {
        var value = a;
        var totalLength = a.length + b.length - "&euro;".length + 1;
        for (var i = 0; i < 48 - totalLength; i++)
            value += " ";
        value += b;

        if (this.displayMode != "info") {
            if (this.SumGrid.properties.value != "")
                value = "\n" + value;

            this.SumGrid.properties.value =
                this.SumGrid.properties.value + value;
        }

        return 13;
    }
}

CBonRenderer.prototype.addSumRawLine = function (a, b, c, d, toPrinter, feed, bold, magnify, font) {
    if (toPrinter) {
        if (typeof font == "undefined")
            font = "A";
        if (typeof bold == "undefined")
            bold = false;
        if (typeof magnify == "undefined")
            magnify = 1;

        Printer.addLine(font, magnify, false, feed);

        var ColLimits = new Array();
        ColLimits[0] = 12;
        ColLimits[1] = 23;
        ColLimits[2] = 31;
        ColLimits[3] = 42;

        if (font == "B")
            for (var i = 0; i < 4; i++)
                ColLimits[i] = Math.ceil(ColLimits[i] * 56 / 42);

        Printer.addElement(a, 0, 0, bold, 0, ColLimits[0] - 1);
        Printer.addElement(b, ColLimits[1] - 1, 1, bold, ColLimits[0], ColLimits[1] - 1);
        Printer.addElement(c, ColLimits[2] - 1, 1, bold, ColLimits[1], ColLimits[2] - 1);
        Printer.addElement(d, ColLimits[3] - 1, 1, bold, ColLimits[2], ColLimits[3] - 1);
    } else {
        var value = "";

        value = this.normalize(a, 13, "left");
        value = value + " " + this.normalize(b, 11, "right");
        value = value + " " + this.normalize(c, 11, "right");
        value = value + " " + this.normalize(d, 11, "right");

        if (this.displayMode != "info") {
            if (this.SumGrid.properties.value != "")
                value = "\n" + value;

            this.SumGrid.properties.value =
                this.SumGrid.properties.value + value;
        }

        return 13;
    }
}

CBonRenderer.prototype.addSumEmptyLine = function (toPrinter, feed) {
    if (toPrinter)
        Printer.addLine("A", 1, false, feed);
}

CBonRenderer.prototype.getSumArray = function () {
    var Cnt;
    var Entry;
    var sum = new Array();

    for (var u = 0; u < 7; u++)
        sum[u] = 0;

    for (Cnt in this.currentBon) {
        Entry = this.currentBon[Cnt];
        if (typeof Entry.cancelled != "undefined" && Entry.cancelled)
            continue;
        if (Entry.type == "BFS")
            continue;

        var level = this.sumLevels[Entry.type];
        var value = Number(Entry.amount) * ((Entry.type == "PAY") ? -1 : 1);

        for (var i in sum)
            if (i >= level)
                sum[i] += value;
    }

    for (i in sum) {
        sum[i] = Math.round(sum[i] * 100) / 100;
    }
    return sum;
}

CBonRenderer.prototype.getBonVat = function (complete) // complete set to true for complete calculation
{
    var Entry;
    var vat = new Array();
    var net = new Array();
    var gro = new Array();
    var vatGroupsVal = new Array();
    var ret = new Array();
    var BonManagerClass = this;
    var defret = $.Deferred();
    var sumRET = 0;
    var sumPAY = 0;

    if (complete) {
        // Go through all BonEntries and correct the VAT
        // Fill Array with VAT Groups
        for (Cnt in BonManagerClass.currentBon) {
            Entry = BonManagerClass.currentBon[Cnt];
            if (Entry.type == "PAY" || Entry.type == "RET") {
                if ((Entry.type == "PAY") && (Entry.interaction == "PDN")) {
                    sumPAY = sumPAY + parseInt(Entry.amount);
                } else if (Entry.interaction == "PDN") {
                    sumRET = sumRET + parseInt(Entry.amount);
                }
                continue;
            }
            if (Entry.reference)
                Entry = Entry.reference;

            if (!Entry.cancelled && Entry.productId && Entry.product &&
                Entry.product.vatGroup &&
                (!(Entry.product.vatGroup in vatGroupsVal) ||
                    vatGroupsVal[Entry.product.vatGroup] > Entry.product.vat))
                vatGroupsVal[Entry.product.vatGroup] = Entry.product.vat;
        }

        // Set vat for all entries
        for (Cnt in BonManagerClass.currentBon) {
            Entry = BonManagerClass.currentBon[Cnt];
            if (Entry.type == "PAY" || Entry.type == "RET")
                continue;
            if (Entry.reference)
                Entry = Entry.reference;

            if (!Entry.cancelled && Entry.productId && Entry.product &&
                Entry.product.vatGroup &&
                (!(Entry.product.vatGroup in vatGroupsVal) ||
                    vatGroupsVal[Entry.product.vatGroup] > Entry.product.vat))
                vatGroupsVal[Entry.product.vatGroup] = Entry.product.vat;
        }
    }

    var redrawEntries = new Array();

    var def2 = $.Deferred();
    var cnts = Object.keys(BonManagerClass.currentBon);
    var iterator = function it(i) {
        if (i < cnts.length) {
            var Cnt = cnts[i];
            Entry = BonManagerClass.currentBon[Cnt];
            if (Entry.type == "PAY" || Entry.type == "RET") {
                return iterator(i + 1);
            }
            var FEntry = Entry;

            if (Entry.reference)
                Entry = Entry.reference;
            if (!Entry.cancelled && Entry.product) {
                var def = $.Deferred();
                if (complete) {
                    if (Entry.product.vatGroup &&
                        Entry.product.vatCorrected != vatGroupsVal[Entry.product.vatGroup]) {
                        Entry.product.vatCorrected = vatGroupsVal[Entry.product.vatGroup];
                        var r = Trans.changeVAT(Entry, Entry.product.vatCorrected);
                        $.when(r).done(function () {
                            // trigger redraw
                            if (Entry.type == "POS")
                                redrawEntries.push(Entry);
                            def.resolve();
                        });
                    }
                    if (!Entry.product.vatGroup && Entry.product.vatCorrected == -1) {
                        Entry.product.vatCorrected = Entry.product.vat;
                        redrawEntries.push(Entry);
                        def.resolve();
                    } else {
                        def.resolve();
                    }
                } else {
                    redrawEntries.push(Entry);
                    def.resolve();
                }

                $.when(def).done(function () {
                    var Amount = (FEntry.amount * Entry.product.vatCorrected) /
                    (1 + Entry.product.vatCorrected);
                    var NetAmount = FEntry.amount - Amount;

                    if (Entry.product.vatCorrected in vat) {
                        vat[Entry.product.vatCorrected] += Amount;
                        net[Entry.product.vatCorrected] += NetAmount;
                        gro[Entry.product.vatCorrected] += FEntry.amount;
                    } else {
                        vat[Entry.product.vatCorrected] = Amount;
                        net[Entry.product.vatCorrected] = NetAmount;
                        gro[Entry.product.vatCorrected] = FEntry.amount;
                    }
                    return iterator(i + 1);
                });
            } else {
                return iterator(i + 1);
            }
        } else {
            var vatSct = new Array();
            var pos = 0;
            for (Cnt in vat) {
                var Sct = String.fromCharCode(65 + pos);
                vatSct[Cnt] = Sct;
                pos++;
            }
            // Set Shortcuts to Entries
            for (Cnt in redrawEntries) {
                Entry = redrawEntries[Cnt];
                Entry.product.vatShortcut = vatSct[Entry.product.vatCorrected];
                BonManagerClass.redrawBonArray[Entry.index] = Entry;
            }

            var sum = BonManagerClass.getSumArray();

            if ((BonManagerClass.isPaydown) || (BonManagerClass.wasPaydown)) {
                //////////////////neu f�r Anzahlung
                if ((BonManagerClass.wasPaydown) && (sum[6] >= 0)) { //letzte Zahlung der Anzahlung
                    var payd = sumPAY - sumRET; //Betrag Anzahlung
                    var taxFac = 1 - payd / sum[4];
                    for (Cnt in vat) {
                        vat[Cnt] = vat[Cnt] * taxFac;
                        net[Cnt] = net[Cnt] * taxFac;
                        gro[Cnt] = gro[Cnt] * taxFac;
                    }
                }

                if ((BonManagerClass.isPaydown) && (sum[5] >= 0)) { //weniger gezahlt als es kostet -< dann wirklich Anzahlung
                    var payd = sum[6] - sum[0]; //Betrag Anzahlung
                    var taxFac = 1 - sum[6] / sum[4];
                    for (Cnt in vat) {
                        vat[Cnt] = vat[Cnt] * taxFac;
                        net[Cnt] = net[Cnt] * taxFac;
                        gro[Cnt] = gro[Cnt] * taxFac;
                    }
                }
            }


            // Correct Global Vat Sum (for Global Rebate)

            if (sum[4] != sum[1]) {
                var taxFac = sum[4] / sum[1];
                for (Cnt in vat) {
                    vat[Cnt] = vat[Cnt] * taxFac;
                    net[Cnt] = net[Cnt] * taxFac;
                    gro[Cnt] = gro[Cnt] * taxFac;
                }
            }

            for (Cnt in vat) {
                vat[Cnt] = vat[Cnt].toFixed(2);
            }

            ret["vat"] = vat;
            ret["net"] = net;
            ret["gro"] = gro;
            ret["sct"] = vatSct;
            defret.resolve(ret);
        }
    }
    iterator(0);
    return defret.promise();
}

CBonRenderer.prototype.showSum = function () {
    if (this.currentBonId == 0)
        return;

    Display.addLine();

    var sum = this.getSumArray();
    if (sum[4] == sum[6])
        var text = POS.lang.getText("LABELS", "SUM") + ":";
    else
        text = POS.lang.getText("LABELS", "OPEN") + ":";

    Display.addElement(text, 0, 0, 0, 19);
    Display.addLine();
    Display.addElement(float2StringD2(this.getSumArray()[6]) + " &euro;", 19, 1, 0, 19);
    Display.out();
}

CBonRenderer.prototype.showRetour = function () {
    if (this.currentBonId == 0)
        return;

    Display.addLine();
    Display.addElement(POS.lang.getText("LABELS", "RETURN") + ":", 0, 0, 0, 19);
    Display.addLine();
    Display.addElement(float2StringD2(this.getSumArray()[5] * -1) + " &euro;", 19, 1, 0, 19);
    Display.out();
}

CBonRenderer.prototype.showPos = function (entry, cancel) {
    if (this.currentBonId == 0)
        return;

    if (POS.sessions.currentSession != this.Main.UID)
        return;

    Display.addLine();

    var priceToShow = " " + float2StringD2(this.getEntrySum(entry)) + " &euro;";
    var lineLength = 19 - priceToShow.length + 5; // + 5 is due to the EUR symbol
    if (!cancel) {
        if (entry.quantity > 1)
            var text = entry.quantity + " " + entry.text1;
        else
            text = entry.text1;
    } else
        text = "-" + entry.quantity + " " + entry.text1;

    Display.addElement(text, 0, 0, 0, lineLength);
    Display.addElement(priceToShow, 19, 1, 0, 19);

    Display.addLine();
    text = POS.lang.getText("LABELS", "SUM") + ":";
    Display.addElement(text, 0, 0, 0, 19);
    Display.addElement(" " + float2StringD2(this.getSumArray()[6]) + " &euro;", 19, 1, 0, 19);

    Display.out();
}

CBonRenderer.prototype.switchSumInfo = function (show) {
    if (this.currentBonId == 0)
        return;

    if (this.SumInfo == null)
        return;

    var Sum = show ? "visible" : "hidden";
    var Entry = show ? "hidden" : "visible";

    this.SumInfo.properties.styles.visibility = Sum;
    this.SumCaption.properties.styles.visibility = Sum;

    if (show) {
        var text,
        text2;
        var sum = this.getSumArray();
        if (sum[4] == sum[6])
            text2 = POS.lang.getText("LABELS", "SUM") + ":";
        else
            text2 = POS.lang.getText("LABELS", "OPEN") + ":";

        text = float2StringD2(sum[6]) + " &euro;";

        this.SumCaption.caption.properties.value = text2;
        this.SumInfo.caption.properties.value = text;
    }
    this.SumInfo.reStyle();
    this.SumInfo.caption.reDraw();
    this.SumCaption.reStyle();
    this.SumCaption.caption.reDraw();
}

export { CBonRenderer };
